export const QueryBranchMapPage = `
fragment branchInfoFragment on OCBInfo {
  key: name
  template: template {
    name
  }
  branchId: field(name: "BranchId") {
    value
  }
  branchName: field(name: "BranchName") {
    value
  }
  branchDistrict {
    targetItem {
      key: name
      ... on OCBDistrict {
        region {
          targetItem {
            ... on OCBRegion {
              regionName {
                value
              }
            }
          }
        }
        districtName {
          value
        }
      }
    }
  }
  branchAddress: field(name: "BranchAddress") {
    value
  }
}

fragment OCBRemarkFragment on OCBRemarks {
  key: name
  RemarksContent: field(name: "RemarksContent") {
    value
  }
  RemarksIcon: remarksIcon {
    ... on ImageField {
      src(maxWidth: null)
    }
  }
  Enabled: field(name: "Enabled") {
    value
  }
}

fragment branchAddressInfoFragment on OCBAddressInfo {
  branchBasicInfo: branchId {
    targetItem {
      ...branchInfoFragment
    }
  }
  addressSupplement {
    value
  }
  branchImage: branchImage {
    ... on ImageField {
      src(maxWidth: null)
    }
  }
  latitude {
    value
  }
  longitude {
    value
  }
  remarks {
    targetItems {
      ...OCBRemarkFragment
    }
  }
  serviceHour {
    value
  }
}

fragment RegionDistrictFragment on OCBDistrict {
  key: name
  region {
    targetItem {
      ... on OCBRegion {
        regionName {
          value
        }
      }
    }
  }
  districtName {
    value
  }
}

fragment OptionsFragment on OCBServicesHour {
  key: name
  serviceHour: field(name: "ServiceHour") {
    value
  }
}

fragment PageGenericFragment on PageGeneric {
  frontendPageComponent {
    targetItem {
      ComponentName: field(name: "ComponentName") {
        value
      }
    }
  }
}

fragment ServiceHoursAddressPage on BranchPage {
  pageTitle {
    value
  }
  header: headerText {
    value
  }
}

query SpecialPage($path: String!, $lang: String!) {
  Content: item(path: $path, language: $lang) {
    key: name
    ...PageGenericFragment
    ...ServiceHoursAddressPage
  }
  BranchInfo: item(path: "/sitecore/content/Sites/JCBW/OCB Branch Address Info/", language: $lang) {
    children {
      ...branchAddressInfoFragment
    }
  }
  RegionDistrict: item(path: "/sitecore/content/Sites/JCBW/Misc/OCBDistrictOptions/", language: $lang) {
    children {
      ...RegionDistrictFragment
    }
  }
  ServiceHourOption: item(path: "/sitecore/content/Sites/JCBW/Misc/OCBServiceHourOptions", language: $lang) {
    children {
      ...OptionsFragment
    }
  }
  OCBRemarks: item(path: "/sitecore/content/Sites/JCBW/OCB Remarks", language: $lang) {
    children {
      ...OCBRemarkFragment
    }
  }
}
`;
